<template>
  <header class="header-global sticky-top">
    <base-nav class="navbar-main navbar-transparent" type="darker" effect expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <h1 class="h3 text-ferdas">Ferdas Hostel Scheme</h1>
        <!-- <img src="img/brand/white.png" alt="logo"> -->
      </router-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-8 collapse-brand">
          <a href="/">
            <span class="text-ferdas h5">Ferdas Hostel Scheme</span>
            <!-- <img src="img/brand/blue.png" /> -->
          </a>
        </div>
        <div class="col-4 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>
      <!-- links /landing /profile /register  -->
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <router-link to="/registered-hostels" class="nav-link">Registered Hostels</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/" class="nav-link">Support Center</router-link>
        </li>
        <base-dropdown>
          <!-- <base-button slot="title" type="primary" class="dropdown-toggle">Primary</base-button> -->
          <div slot="title">
            <img
              v-lazy="'/img/theme/team-4-800x800.jpg'"
              style="width: 50px;"
              class="d-inline-block rounded-circle mr-2 img-fluid"
              alt="Kitten"
            />
            <span
              class="py-3 dropdown-toggle"
              style="font-size: 0.9rem;
                font-family: 'Overpass Mono';
                font-weight: 700;
                text-transform: normal;
                letter-spacing: 0;
                -webkit-transition: all 0.15s linear;
                transition: all 0.15s linear; color:white;"
              data-offset="10,20"
            >Profile</span>
          </div>
          <a class="dropdown-item" href="/profile/jane-doe">My Profile</a>
          <a class="dropdown-item" href="#">Edit Account</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="/">Logout</a>
        </base-dropdown>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
